import PropTypes from 'prop-types'
import { AsyncPaginate } from 'react-select-async-paginate'
import { components } from 'react-select'
import { ChevronDown, X } from 'react-feather'
import { Spinner } from 'reactstrap'

const ClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <X size={16} />
  </components.ClearIndicator>
)

const DropdownIndicator = (props) => {
  const { isLoading } = props.selectProps
  if (isLoading) {
    return (
      <components.DropdownIndicator {...props}>
        <Spinner size="sm" color="primary" />
      </components.DropdownIndicator>
    )
  }
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDown size={18} />
    </components.DropdownIndicator>
  )
}

const PMBAsyncSelectPaginate = ({
  loadOptions,
  value,
  onChange,
  placeholder = 'Ketik untuk mencari...',
  title,
  isMulti = false,
  isClearable = true,
  isDisabled = false,
  isInvalid = false,
  debounceTimeout = 300,
  additional = { page: 1 },
  testId = 'pmb-async-paginate-select',
  className = '',
  menuPlacement = 'auto',
  menuPosition = 'fixed',
  noOptionsMessage = () => 'Tidak ada data ditemukan',
  loadingMessage = () => 'Memuat data...',
  ...rest
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: isInvalid
        ? '#dc3545'
        : state.isFocused
        ? '#006386'
        : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 1px #006386' : 'none',
      '&:hover': {
        borderColor: isInvalid ? '#dc3545' : '#006386',
      },
      borderRadius: '8px',
      padding: '2px',
      backgroundColor: state.isDisabled ? '#f8f9fa' : '#ffffff',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
      minHeight: '40px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#1f2937',
      fontSize: '14px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9ca3af',
      fontSize: '14px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#6b7280',
      padding: '6px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#6b7280',
      padding: '6px',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled
        ? 'transparent'
        : state.isSelected
        ? '#006386'
        : state.isFocused
        ? '#e0f2fe'
        : 'transparent',
      color: state.isDisabled
        ? '#9ca3af'
        : state.isSelected
        ? '#ffffff'
        : '#1f2937',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
      fontSize: '14px',
      padding: '8px 12px',
      opacity: state.isDisabled ? 0.6 : 1,
      '&:active': {
        backgroundColor: state.isDisabled ? 'transparent' : '#006386',
        color: state.isDisabled ? '#9ca3af' : '#ffffff',
      },
    }),
  }

  const mergedStyles = rest.styles
    ? Object.keys(customStyles).reduce(
        (acc, key) => {
          acc[key] = (provided, state) => {
            const base = customStyles[key] ? customStyles[key](provided, state) : provided
            return rest.styles[key] ? rest.styles[key](base, state) : base
          }
          return acc
        },
        { ...rest.styles },
      )
    : customStyles

  return (
    <div className={`pmb-async-paginate-wrapper ${className}`}>
      {title && (
        <label
          className="d-block mb-1 fw-semibold text-dark text-sm"
          data-testid={`${testId}-label`}
        >
          {title}
        </label>
      )}

      <AsyncPaginate
        data-testid={testId}
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        placeholder={placeholder}
        isMulti={isMulti}
        isClearable={isClearable}
        isDisabled={isDisabled}
        debounceTimeout={debounceTimeout}
        additional={additional}
        components={{
          DropdownIndicator,
          ClearIndicator,
        }}
        menuPlacement={menuPlacement}
        menuPosition={menuPosition}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        noOptionsMessage={noOptionsMessage}
        loadingMessage={loadingMessage}
        {...rest}
        styles={mergedStyles}
      />
    </div>
  )
}

PMBAsyncSelectPaginate.propTypes = {
  loadOptions: PropTypes.func.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  debounceTimeout: PropTypes.number,
  additional: PropTypes.object,
  testId: PropTypes.string,
  className: PropTypes.string,
  menuPlacement: PropTypes.string,
  menuPosition: PropTypes.string,
  noOptionsMessage: PropTypes.func,
  loadingMessage: PropTypes.func,
}

export default PMBAsyncSelectPaginate
